import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import AIDevelopment from "./pages/AIDevelopment";
import AIConsulting from "./pages/AIConsulting";
import About from "./pages/About";
import Resources from "./pages/Resources";
import ResourceDetail from "./pages/ResourceDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminResources from "./pages/AdminResources";
import AdminResourceForm from "./pages/AdminResourceForm";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import Chatbot from "./components/Chatbot";
import CustomRagDemo from "./pages/CustomRagDemo";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/software-development" element={<SoftwareDevelopment />} />
            <Route path="/ai-development" element={<AIDevelopment />} />
            <Route path="/ai-consulting" element={<AIConsulting />} />
            <Route path="/about" element={<About />} />
            <Route path="/custom-rag-demo" element={<CustomRagDemo />} />
            
            {/* Resources Routes */}
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceDetail />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/resources" 
              element={
                <AdminProtectedRoute>
                  <AdminResources />
                </AdminProtectedRoute>
              } 
            />
            <Route 
              path="/admin/resource-form" 
              element={
                <AdminProtectedRoute>
                  <AdminResourceForm />
                </AdminProtectedRoute>
              } 
            />
            <Route 
              path="/admin/resource-form/:id" 
              element={
                <AdminProtectedRoute>
                  <AdminResourceForm />
                </AdminProtectedRoute>
              } 
            />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
          
          {/* Global Chatbot - Available on all pages */}
          <Chatbot />
        </BrowserRouter>
        <Toaster />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
